export default __webpack_public_path__ + "static/media/anniliya.d71d3c4d.jpeg";